module.exports = __webpack_public_path__ + "static/media/my_cart_french.ac73e20e.png";